import React, { forwardRef, ReactNode } from 'react';
import { Box as ChakraBox, BoxProps, useStyleConfig } from '@chakra-ui/react';

interface Props extends Omit<BoxProps, `css`> {
  children?: ReactNode;
}

export const Card = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`Card`);

    return (
      <ChakraBox ref={ref} __css={styles} {...props}>
        {children}
      </ChakraBox>
    );
  }
);
export type { Props as CardProps };
